export function isEmail(emailAdress) {
    let regex = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line
    if (emailAdress.match(regex))
        return true;
    else return false;
}